import request from '../util/http'

export function prtcApply(params) {
  return request({
    url: '/zcjf/biz/guarantee/bank/sxpt/prtcApply',
    method: 'get',
    params,
  })
}
